module.exports = __webpack_public_path__ + "static/media/LethalTempo.6fe24bce.png";